import Popper from 'popper.js'
;(window as any).Popper = Popper
